// Resolve an image URL: if it's a /api/files/... path, prefix with backend host
export function resolveImageUrl(url) {
  if (!url) return "";
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  if (url.startsWith("/api/")) {
    return `${process.env.REACT_APP_BACKEND_URL}${url}`;
  }
  return url;
}
